export enum WhatsAppTemplateType {
  RegistrationConfirmation = 0,
  InStoreRegistration = 1,
  ForgotPassword = 2,
  VerificationCode = 3,
  OrderCreated = 4,
  PaymentConfirmed = 5,
  OrderCancelled = 6,
  NfeEmitted = 7
};
